import { DefaultTheme, ITheme } from "../store/slices/theme";
import { IFullTheme, IThemeImages } from "../types/theme";

export const APP_URL = `${window.location.origin}`;

const THEME_NAME = import.meta.env.VITE_THEME_NAME || "tgp";
export const getThemeConfig = async (): Promise<ITheme> => {
  let themeConfig: IFullTheme = DefaultTheme as IFullTheme;
  const response = await fetch(`/themes/${THEME_NAME}/config.json`);
  themeConfig = await response.json();

  return {
    ...DefaultTheme,
    ...themeConfig,
    colors: {
      ...DefaultTheme.colors,
      ...themeConfig.colors,
    },
  };
};

export const getThemeImages = (): IThemeImages => {
  const folderPath = `${APP_URL}/themes/${THEME_NAME}/images`;
  return {
    headerLogo: `${folderPath}/header.svg`,
    notchLogo: `${folderPath}/notch.svg`,
    notchBadgeLogo: `${folderPath}/notchBadge.svg`,
    achievementHeader: `${folderPath}/achievement_header.svg`,
    rankHeader: `${folderPath}/rank_header.webp`,

    loadingLogo: getResponsiveImages(folderPath, "logo"),
    checkIcon: getResponsiveImages(folderPath, "check-icon"),
    rankBG: getResponsiveImages(folderPath, "rank"),
  };
};

const getResponsiveImages = (
  folderPath: string,
  fileName: string,
  extension = "webp"
) => {
  return {
    "1x": `${folderPath}/${fileName}_1x.${extension}`,
    "2x": `${folderPath}/${fileName}_2x.${extension}`,
    "3x": `${folderPath}/${fileName}_3x.${extension}`,
  };
};

export const assetsImages: IThemeImages = getThemeImages();
